module.exports = __webpack_public_path__ + "img/needle.33312466.svg";